
import React, { useState, useEffect } from "react";
import Button from "../../components/ui/Button";
import InputWithIcon from "../../components/ui/InputWithIcon";
import api from "../../api/api";

const StockHeader = ({
  orderDetails,
  user,
  setSuccess,
  setError,
  setOrderDetails,
}) => {
  const [loading, setLoading] = useState(false);
  const [orderDate, setOrderDate] = useState("");

  // --- Timezone-safe date formatter (yyyy-mm-dd for input[type=date]) ---
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "";

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // --- Initialize fields ---
  useEffect(() => {
    if (orderDetails) {
      const rawDate =
        orderDetails.StockDate ||
        orderDetails.stockDate ||
        orderDetails.Podate ||
        orderDetails.podate;
      setOrderDate(formatDate(rawDate));
    }
  }, [orderDetails]);

  const handleUpdateOrder = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      // Backend expects ISO datetime (not yyyy-mm-dd)
      const isoDate = new Date(orderDate).toISOString();

      await api.post("MobupdateStklistAPI", {
        Poid: orderDetails?.Poid || orderDetails?.DocNo || orderDetails?.id,
        StockDate: isoDate,
        User: user?.UsrName || "",
      });

      if (setOrderDetails) {
        setOrderDetails((prev) => ({
          ...prev,
          StockDate: isoDate,
        }));
      }

      setSuccess("Order details updated successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      console.error(err);
      setError("Failed to update order.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-xl mx-auto bg-white shadow-lg rounded-xl p-6">
      <h2 className="text-lg sm:text-xl font-bold mb-4 text-center">
        Order Info
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Stock Type */}
        <InputWithIcon
          label="Stock Type"
          id="stockType"
          value={
            orderDetails?.Vname ||
            orderDetails?.vname ||
            orderDetails?.VName ||
            "-"
          }
          readOnly
        />

        {/* Godown */}
        <InputWithIcon
          label="Godown"
          id="godown"
          value={
            orderDetails?.godownName ||
            orderDetails?.GodownName ||
            orderDetails?.StkGodownName ||
            "-"
          }
          readOnly
        />

        {/* Order Date */}
        <div>
          <label className="block mb-2 text-sm font-bold text-gray-700">
            Order Date
          </label>
          <input
            type="date"
            value={orderDate}
            onChange={(e) => setOrderDate(e.target.value)}
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <Button
          type="button"
          onClick={handleUpdateOrder}
          disabled={loading}
          className="px-4 py-2"
        >
          {loading ? "Updating..." : "Update Order"}
        </Button>
      </div>
    </div>
  );
};

export default StockHeader;
